export default __webpack_public_path__ + "images/1b9378186a0427c70cbaa72b2d973327-checkMark.svg";